import Select from 'react-select';
import React, { useState } from 'react';

const options = [
  // options array here
  { value: 'Mombasa', label: 'Mombasa' },
  { value: 'Kwale', label: 'Kwale' },
  { value: 'Kilifi', label: 'Kilifi' },
  { value: 'Tana River', label: 'Tana River' },
  { value: 'Lamu', label: 'Lamu' },
  { value: 'Taita/Taveta', label: 'Taita/Taveta' },
  { value: 'Garissa', label: 'Garissa' },
  { value: 'Wajir', label: 'Wajir' },
  { value: 'Mandera', label: 'Mandera' },
  { value: 'Marsabit', label: 'Marsabit' },
  { value: 'Isiolo', label: 'Isiolo' },
  { value: 'Meru', label: 'Meru' },
  { value: 'Tharaka-Nithi', label: 'Tharaka-Nithi' },
  { value: 'Embu', label: 'Embu' },
  { value: 'Kitui', label: 'Kitui' },
  { value: 'Machakos', label: 'Machakos' },
  { value: 'Makueni', label: 'Makueni' },
  { value: 'Nyandarua', label: 'Nyandarua' },
  { value: 'Nyeri', label: 'Nyeri' },
  { value: 'Kirinyaga', label: 'Kirinyaga' },
  { value: 'Murang\'a', label: 'Murang\'a' },
  { value: 'Kiambu', label: 'Kiambu' },
  { value: 'Turkana', label: 'Turkana' },
  { value: 'West Pokot', label: 'West Pokot' },
  { value: 'Samburu', label: 'Samburu' },
  { value: 'Trans Nzoia', label: 'Trans Nzoia' },
  { value: 'Uasin Gishu', label: 'Uasin Gishu' },
  { value: 'Elgeyo/Marakwet', label: 'Elgeyo/Marakwet' },
  { value: 'Nandi', label: 'Nandi' },
  { value: 'Baringo', label: 'Baringo' },
  { value: 'Laikipia', label: 'Laikipia' },
  { value: 'Nakuru', label: 'Nakuru' },
  { value: 'Narok', label: 'Narok' },
  { value: 'Kajiado', label: 'Kajiado' },
  { value: 'Kericho', label: 'Kericho' },
  { value: 'Bomet', label: 'Bomet' },
  { value: 'Kakamega', label: 'Kakamega' },
  { value: 'Vihiga', label: 'Vihiga' },
  { value: 'Bungoma', label: 'Bungoma' },
  { value: 'Busia', label: 'Busia' },
  { value: 'Siaya', label: 'Siaya' },
  { value: 'Kisumu', label: 'Kisumu' },
  { value: 'Homa Bay', label: 'Homa Bay' },
  { value: 'Migori', label: 'Migori' },
  { value: 'Kisii', label: 'Kisii' },
  { value: 'Nyamira', label: 'Nyamira' },
  { value: 'Nairobi City', label: 'Nairobi City' },
  {value: 'Diaspora', label: 'Diaspora'}
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: 'none',
    boxShadow: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#6B7280' : 'white',
    color: state.isSelected ? 'white' : 'black',
  }),
  input: (provided) => ({
    ...provided,
    padding: '0.5rem',
  }),
};

function County() {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelect = (selectedOption) => {
    setSelectedOption(selectedOption);
    localStorage.setItem('county', selectedOption.value);
  };

  return (
    <div>
      <Select
        options={options}
        styles={customStyles}
        className="mx-auto w-full max-w-xs p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 "
        isSearchable={true}
        value={selectedOption}
        onChange={handleSelect}
      />
    </div>
  );
}

export default County;
